import type { LandingBlock, LandingTheme } from '~/(tenant)/_lib/schema/landing-config.schema';

export function resolveLandingMotion(theme?: LandingTheme, design?: LandingBlock['design']) {
  const mode = theme?.scrollMotion ?? 'none';
  const defaultReveal = mode === 'expressive' ? 'rise' : mode === 'subtle' || design?.stagger === true ? 'fade' : 'none';
  const reveal = design?.reveal ?? defaultReveal;
  return {
    reveal,
    parallax: design?.parallax ?? (mode === 'expressive' ? 'subtle' : 'none'),
    stagger: reveal !== 'none' && (design?.stagger ?? mode === 'expressive'),
    intensity: mode === 'expressive' ? 'expressive' : 'subtle',
  } as const;
}

export function landingParallaxTransform({ top, height, viewportHeight, viewportWidth, strength }: {
  top: number;
  height: number;
  viewportHeight: number;
  viewportWidth: number;
  strength: 'subtle' | 'strong';
}) {
  if (height <= 0 || viewportHeight <= 0) return 'none';
  const travel = Math.min((strength === 'strong' ? 48 : 24) * (viewportWidth < 768 ? 0.5 : 1), height * 0.12);
  const progress = Math.max(-1, Math.min(1, (viewportHeight / 2 - top - height / 2) / ((viewportHeight + height) / 2)));
  return `translate3d(0, ${(progress * travel).toFixed(2)}px, 0) scale(${(1 + (travel * 2) / height + 0.02).toFixed(4)})`;
}
